export default __webpack_public_path__ + "images/blue-milky-way.svg";